import React from "react";
import "./App.css";
import "./index.css";
import './components/common-components/common_css/Form_Css.css'

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Contact_Us from "./components/contact_us/Contact_Us";
import FAQ from "./components/faq/FAQ";
import About_Us from "./components/about_us/About_Us";
import Products from "./components/products/Products";
import Product_description from "./components/product-description/Product_description";
import ScrollToTop from "./components/common-components/ScrollToTop/ScrollToTop";
import TermsConditions from "./components/termsandconditions/Termsconditions";
import Privacypolicy from "./components/privacypolicy/Privacypolicy";


function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact-us" element={<Contact_Us />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/all-products" element={<Products />} />
        <Route path="/products/:id" element={<Product_description />} />
        <Route path="/termsandconditions" element={<TermsConditions />} />
        <Route path="/privacypolicy" element={<Privacypolicy />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
